import { styled } from 'linaria/react';
import { NAVIGATION_HEIGHT } from 'components/Navigation/helpers/constants';
import { COLORS, FONTS, BREAKPOINTS } from '../../../styles/constants';

export const StyledWrap = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: ${BREAKPOINTS.s}px;
  .swiper {
    padding: 8px 24px 12px 24px;
  }
`;

export const RadioButtonWrap = styled.div<{ isDark: boolean }>`
  > input {
    display: none;
  }

  > label {
    background: ${({ isDark }) => (isDark ? `${COLORS.white[10]}` : `${COLORS.white.off[100]}`)};
    color: ${({ isDark }) => (isDark ? `${COLORS.white[100]}` : `${COLORS.brown.dark[100]}`)};
  }

  > input[type='radio']:disabled + label {
    color: ${COLORS.brown.light[100]};
  }

  > input[type='radio']:checked + label {
    background-color: ${({ isDark }) => (isDark ? `${COLORS.white[100]}` : `${COLORS.brown.dark[100]}`)};
    color: ${({ isDark }) => (isDark ? `${COLORS.brown.dark[100]}` : `${COLORS.white[100]}`)};
  }
`;

export const StyledLabel = styled.label<{ isDisabled: boolean }>`
  border-radius: 22px;
  border: none;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  display: block;
  font: 600 14px/140% ${FONTS.secondary};
  padding: 12px 20px;
  white-space: nowrap;

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledFixedTabs = styled.div<{ isHide: boolean; bgColor?: string }>`
  position: fixed;
  top: ${({ isHide }) => (isHide ? `-${NAVIGATION_HEIGHT + 48}px` : `${NAVIGATION_HEIGHT}px`)};
  opacity: ${({ isHide }) => (isHide ? 0 : 1)};
  left: 0;
  width: 100%;
  z-index: 199;
  transition: top 0.18s ease-in-out, opacity 0.18s ease-in-out;
  background-color: ${({ bgColor }) => bgColor ?? 'transparent'};
  display: flex;
  justify-content: center;
  align-items: center;
`;
